import { getFetch } from '../fetch';

import { apiConfig } from '../config';

import type { SolveSession, CodeHistory } from '../../../typings/api/defs/problems';

type GetSolveSessionResult = GetSolveSessionData | { type: 'not_found' };

interface GetSolveSessionData {
    type: 'success';
    data: {
        paste_detected: boolean;
        history: CodeHistory;
    };
}

export async function getSolveSession(params: {
    problemLinkId: number;
    studentId?: number | undefined;
}): Promise<SolveSession | null> {
    const { apiGetSolveSession } = apiConfig.getStaticUrls();

    const result: GetSolveSessionResult = await getFetch(apiGetSolveSession, {
        lpl_id: params.problemLinkId,
        student_id: params.studentId,
    });

    if (result.type === 'not_found') {
        return null;
    }

    return {
        pasteDetected: result.data.paste_detected,
        history: result.data.history,
    };
}
